import { render, staticRenderFns } from "./TeacherManagement.vue?vue&type=template&id=55a9db94&scoped=true&"
import script from "./TeacherManagement.vue?vue&type=script&lang=js&"
export * from "./TeacherManagement.vue?vue&type=script&lang=js&"
import style0 from "./TeacherManagement.vue?vue&type=style&index=0&id=55a9db94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a9db94",
  null
  
)

export default component.exports